import React from "react"
import MultisaverCards from "./multisaver-cards"
import CoverageMap from "@slice/mobile-coverage-map"
import RoamingMap from "./roaming-map"
//import MobileCalculator from './mobile-calculator'
import MobileCalculator from "@slice/mobile-multisaver-calculator"
//import MultisaverSignup from '@slice/multisaver-signup'
import NetworkStatusPanel from "@slice/network-status-panel"
import OfferGridSwitch from "@slice/offer-grid/switch"

const ssr = {
  "multisaver-cards": MultisaverCards,
  "coverage-map": CoverageMap,
  "roaming-map": RoamingMap,
  "mobile-multisaver-calculator": MobileCalculator,
  "network-status": NetworkStatusPanel,
  "offer-grid-switch":  OfferGridSwitch
}

const client = {
  "offpeak-regions": React.lazy(() => import("../offpeak-regions")),
  "phone-services": React.lazy(() => import("./phone-services")),
  /*'multisaver-signup': React.lazy(() =>
        import('@slice/multisaver-signup')
    ),*/
  "multisaver-options": React.lazy(() => import("./multisaver-options")),
}

const Custom = ({ component, settings, ...props }) => {
  settings = settings ? JSON.parse(settings) : {}

  const isSSR = typeof window === "undefined"

  if (ssr.hasOwnProperty(component)) {
    const Component = ssr[component]
    return (
      <Component
        data-type={component}
        env={process.env.GATSBY_SITE}
        {...settings}
      />
    )
  } else if (client.hasOwnProperty(component) && isSSR === false) {
    const ClientSideOnlyLazy = client[component]

    return (
      <>
        {!isSSR && (
          <React.Suspense fallback={<span />}>
            <ClientSideOnlyLazy
              data-type={component}
              env={process.env.GATSBY_SITE}
              {...settings}
            />
          </React.Suspense>
        )}
      </>
    )
  }

  return <></>
}
export default Custom
